<template>
  <div>
    <v-container>
      <v-row>
        <v-col :style="loggedIn ? 'display: flex; align-items: center;' : ''">
          <div class="tx-3 tx-b-700 tx-dark-gray tx-mt-0 mt-4">
            Historia firmy
          </div>
        </v-col>
      </v-row>
      <v-row class="pa-3">
        <v-timeline dense class="v-timeline--fluid">
          <v-timeline-item
            v-for="(historyEntry, i) in historyEntries"
            fill-dot
            :key="i"
            color="#0C9A9A"
          >
            <v-card outlined color="#e9e9e9">
              <v-card-title class="tx-2 tx-dark-gray tx-mt-0"
                >{{ new Date(historyEntry.date).getFullYear() }}
              </v-card-title>
              <v-card-text class="tx-4 tx-mt-0">
                {{ historyEntry.content }}
                <div v-html="historyEntry.link"></div>
              </v-card-text>
            </v-card>
          </v-timeline-item>
        </v-timeline>
      </v-row>
    </v-container>
  </div>
</template>

<script>
import websiteContents from "@/website-contents";

export default {
  name: "company-history-component",
  mounted() {
    this.getHistoryEntries();
  },
  data: function() {
    return {
      historyEntries: null
    };
  },
  computed: {
    loggedIn: function() {
      return this.$store.state.authentication.loggedIn;
    }
  },
  methods: {
    getHistoryEntries() {
      this.historyEntries = websiteContents.historyEntries;
      this.$emit("loading-finished");
    }
  }
};
</script>

<style scoped>
.v-timeline--fluid {
  width: 100%;
}
</style>
